import React, { useEffect } from 'react';
import SiteNav, { MUSIC_NAV_LINKS } from '../components/SiteNav';
import HappyTreeValleyTunes from '../components/HappyTreeValleyTunes';
import ParentNewsletterCta from '../components/ParentNewsletterCta';
import useNavSolid from '../hooks/useNavSolid';
import { PUBLIC_SITE_ORIGIN } from '../config';
import { MUSIC_PREVIEW_SECONDS } from '../data/music';
import happyTreeThumb from '../assets/happy-tree-valley-thumb.png';

export default function MusicPage() {
  const navSolid = useNavSolid(24);

  useEffect(() => {
    document.title = 'Happy Tree Valley Tunes — Libby the Lion & Friends';
    const canonical = `${PUBLIC_SITE_ORIGIN}/music`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', canonical);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', canonical);
  }, []);

  return (
    <div className="v2-shell tunes-shell">
      <SiteNav solid={navSolid} links={MUSIC_NAV_LINKS} brandHref="/" />
      <header className="tunes-hero">
        <div className="tunes-hero__inner">
          <img
            src={happyTreeThumb}
            alt=""
            className="tunes-hero__thumb"
            width={640}
            height={360}
            decoding="async"
            aria-hidden
          />
          <p className="section-eyebrow">Happy Tree Valley</p>
          <h1 className="section-display">Tunes</h1>
          <p className="tunes-hero__lead">
            Listen to {MUSIC_PREVIEW_SECONDS}-second previews of Libby&apos;s songs here in Happy Tree Valley — tap
            play when you&apos;re
            ready. Streaming only on this site; full tracks are not offered for download.
          </p>
        </div>
      </header>

      <main className="tunes-main">
        <HappyTreeValleyTunes />
        <p className="tunes-note">
          Nothing autoplays. Each song plays up to a {MUSIC_PREVIEW_SECONDS}-second preview. These clips are for listening on
          libbythelion.com only — please don&apos;t redistribute recordings from your browser.
        </p>
        <ParentNewsletterCta variant="music" />
      </main>

      <footer className="v2-footer tunes-footer">
        <div className="footer-title-band">
          <p className="footer-line">
            <a href="/">← Back to Libby the Lion &amp; Friends</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
